import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ArtistRow from '@/components/common/ArtistRow.vue';
import DiscountList from './DiscountList.vue';
import SaleLabelList from './SaleLabel-list.vue';
import LazyImage from './LazyImage.vue';
import DiscountTag from './DiscountTag.vue';
import GroupInfo from './GroupInfo.vue';
import Drip from 'drip';
import Star from 'comp/star/Star';
import { getStar } from '@/utils/getStar';
import { parseDetailUrl } from "@/utils";
export default {
  name: 'detail-entrance',
  props: ['show', 'index', 'bid', 'viewBid', 'isCalendarPage', 'isBrandPage', 'showTopInfo', 'isSearch', 'categoryId', 'projectId', 'isRecommand' // 用于修改DiscountList推荐模块缩进样式
  ],

  components: {
    ArtistRow: ArtistRow,
    SaleLabelList: SaleLabelList,
    LazyImage: LazyImage,
    DiscountList: DiscountList,
    Star: Star,
    DiscountTag: DiscountTag,
    GroupInfo: GroupInfo
  },
  mounted: function mounted() {
    this.getPrice();
  },
  data: function data() {
    return {
      computePrice: '',
      priceSuffix: '',
      cityId: Drip.constant.cityId,
      showGroup: true
    };
  },
  watch: {
    'show.priceRange': {
      handler: function handler(val, old) {
        var _this = this;
        this.computePrice = '';
        this.$nextTick(function () {
          _this.getPrice();
        });
      },
      deep: true
    }
  },
  computed: {
    discountImg: function discountImg() {
      var listActivityTagUrl = this.show && this.show.couponActivityTagVO && this.show.couponActivityTagVO.listActivityTagUrl;
      return listActivityTagUrl || '';
    },
    showGeneralAgentIcon: function showGeneralAgentIcon() {
      if (!this.show) return false;
      var _this$show = this.show,
        exclusive = _this$show.exclusive,
        generalAgent = _this$show.generalAgent;
      if (generalAgent && !exclusive) {
        return true;
      }
      return false;
    },
    showExclusiveAgentIcon: function showExclusiveAgentIcon() {
      return this.show && !!this.show.exclusive;
    },
    showOwnerTag: function showOwnerTag() {
      return this.show.exclusive && [1, 2, 3, 11].includes(this.show.performanceLabelVO.saleLabel);
    },
    showXZGP: function showXZGP() {
      return !this.show.unusualSaleStatus && !!this.show.seatType && this.show.seatType !== 0 && [2, 3].includes(this.show.performanceLabelVO.saleLabel);
    },
    // 是否展示销售状态标签
    showSaleLabel: function showSaleLabel() {
      return this.show.categoryId !== 14;
    },
    showPrice: function showPrice() {
      return this.show.performanceLabelVO.saleLabel !== 5;
    },
    showSelf: function showSelf() {
      return this.show.self && this.show.performanceLabelVO.saleLabel !== 5;
    },
    showOtherChannel: function showOtherChannel() {
      return !this.show.self && this.show.thirdPartyDesc && this.show.performanceLabelVO.saleLabel !== 5;
    },
    showDiscountInfo: function showDiscountInfo() {
      var priceRangeType = this.show && this.show.priceRangeType;
      var hasPromotionVoPrice = this.show && this.show.promotionVO && this.show.promotionVO.minSellPrice;
      var showDiscountSaleLabel = [];
      if (priceRangeType != 1 || hasPromotionVoPrice) {
        showDiscountSaleLabel = [1, 11, 2, 3];
      } else {
        showDiscountSaleLabel = [2, 3];
      }
      return showDiscountSaleLabel.includes(this.show.performanceLabelVO.saleLabel) || this.show.promotional && this.show.promotional.supportWenhui;
    },
    showSeeLabel: function showSeeLabel() {
      return this.show.relievedTagVO && this.show.relievedTagVO.isRelieved === 0;
    },
    // 是否是游戏剧场项目
    isGameProject: function isGameProject() {
      return this.show.categoryId === 14;
    },
    // 是否是拼场售卖
    isShowPoolSale: function isShowPoolSale() {
      //  1-拼场，2-单独售卖
      return this.show.saleType === 1;
    },
    // 品牌馆列表，无座项目不展示在售中标签
    isHideSaleTag: function isHideSaleTag() {
      return !(this.show.seatType === 0 && this.show.performanceLabelVO.saleLabel === 3 && this.isBrandPage);
    },
    isGroupInfoHasMarginTop: function isGroupInfoHasMarginTop() {
      return !(this.showDiscountInfo && !this.isBrandPage);
    }
  },
  methods: {
    getStarNum: getStar,
    to: function to(e) {
      try {
        var target = e.currentTarget;
        var _target$dataset = target.dataset,
          performanceid = _target$dataset.performanceid,
          itemindex = _target$dataset.itemindex,
          _target$dataset$jumpd = _target$dataset.jumpdetailurl,
          jumpdetailurl = _target$dataset$jumpd === void 0 ? "" : _target$dataset$jumpd;
        this.$emit('clickStatus', {
          performance_id: performanceid,
          index: itemindex,
          performanceid: performanceid,
          itemindex: itemindex,
          project_id: this.projectId
        });
        if (jumpdetailurl) {
          Drip.redirect("/myshow/#".concat(parseDetailUrl(jumpdetailurl)));
        } else {
          Drip.redirect("/myshow/#/detail/".concat(this.show.performanceId));
        }
      } catch (e) {
        console.log('clickStatus error', e);
      }
    },
    getPrice: function getPrice() {
      var detailDom = this.$refs.detail;
      if (detailDom && detailDom.offsetWidth && this.show.priceRange !== '价格待定') {
        var tips = detailDom.querySelectorAll('.i-tips-compute');
        var tipsWidth = Array.prototype.reduce.call(tips, function (t, c) {
          return t + c.offsetWidth;
        }, 12);
        if (detailDom.offsetWidth <= tipsWidth) {
          this.computePrice = this.show.priceRange.split('-')[0];
          this.priceSuffix = '起';
        } else if (!this.priceSuffix) {
          this.computePrice = this.show.priceRange;
          this.priceSuffix = '';
        }
      }
    },
    initPrice: function initPrice(priceRange) {
      if (priceRange && priceRange !== '价格待定') {
        var priceArr = priceRange.split('-');
        if (priceArr.length > 1) {
          return [priceArr[0], '起'];
        } else if (priceArr.length === 1) {
          return [priceArr[0], ''];
        } else {
          return ['', ''];
        }
      }
      return ['', ''];
    },
    onGroupCountDownFinish: function onGroupCountDownFinish() {
      this.showGroup = false;
    }
  }
};